import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    maxWidth: '95%',
    margin: '0 10'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function PickupStore({store, onViewMap, onSelectStore}) {
  const classes = useStyles();
  

  return (
    <Card className={classes.root}>
      <CardContent>

        <Typography variant="h5" component="h2">
          {store.name}
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          Working Hours: {store.workingHours}
        </Typography>
        <Typography variant="body2" component="p">
          {store.address}
        </Typography>
      </CardContent>
      <CardActions>
        <Button onClick={() => onSelectStore(store)} size="small">SELECT</Button>
        <Button onClick={() => onViewMap(store)} size="small">VIEW IN MAP</Button>
      </CardActions>
    </Card>
  );
}
